module.exports = __webpack_public_path__ + "static/img/sm11.0819b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm11.jpg
// module id = VIq7
// module chunks = 1